import React, { useEffect } from "react";
import { QRCode } from "react-qrcode-logo";
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';


const ApplyForQrScreen = ({ param }) => {
  const { state } = useLocation()
  const route = useNavigate()

  useEffect(() => {
    console.log(state)
  }, []);

  return (
    <>    {!state ? route("/ApplyForQrFormScreen") : <div className="text-center">
      <div className="text-Secondary text-2xl font-bold">Tu QR</div>
      <div className="font-semibold">Comparte tu código Qr para que te compartan un Fiado</div>
      <div className="font-semibold py-3">Monto: ${state.amount} MXN</div>
      <div className="font-semibold">Concepto: {state.concept}</div>

      <div className="flex justify-center p-4">
        <QRCode
          value={JSON.stringify({
            type: "dynamic",
            phoneNumber: JSON.parse(localStorage.getItem("tokenDecoded")).phone_number,
            amount: state.amount,
            concept: state.concept,
          })}

          size={270}          
        />
      </div>
    </div>}
    </>

  );
};

export default ApplyForQrScreen;